import { useEffect, useState } from "react";

function VoiceConfiguration({ onChange, settings }) {
  const [speechConfig, setSpeechConfig] = useState({
    speech_rate: settings?.speech_rate ?? 1,
    speech_pitch: settings?.speech_pitch ?? 1,
    speech_volume: settings?.speech_volume ?? 1,
  });

  useEffect(() => {
    setSpeechConfig({
      speech_rate: settings?.speech_rate ?? 1,
      speech_pitch: settings?.speech_pitch ?? 1,
      speech_volume: settings?.speech_volume ?? 1,
    });
  }, [settings]);

  const _onChange = (field, value) => {
    setSpeechConfig((prevState) => ({ ...prevState, [field]: value }));
    onChange(field, value);
  };

  const resetDefaults = () => {
    _onChange("speech_rate", 1);
    _onChange("speech_pitch", 1);
    _onChange("speech_volume", 1);
  };

  return (
    <>
      <div className="card my-4">
        <div className="card-body">
          <h5 className="card-title">
            <i className="bi bi-sliders me-2"></i>
            Voice Settings
          </h5>

          <div className="row g-4">
            <div className="col-md-4">
              <label className="form-label fw-bold">
                <i className="bi bi-speedometer2 me-2"></i>
                Speed: {speechConfig?.speech_rate}x
              </label>
              <input
                type="range"
                min="0.5"
                max="2"
                step="0.1"
                value={speechConfig?.speech_rate}
                onChange={(e) =>
                  _onChange("speech_rate", parseFloat(e.target.value))
                }
                className="form-range"
              />
              <div className="d-flex justify-content-between small text-muted">
                <span>Slow</span>
                <span>Normal</span>
                <span>Fast</span>
              </div>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-bold">
                <i className="bi bi-music-note-beamed me-2"></i>
                Pitch: {speechConfig?.speech_pitch}
              </label>
              <input
                type="range"
                min="0.5"
                max="2"
                step="0.1"
                value={speechConfig?.speech_pitch}
                onChange={(e) =>
                  _onChange("speech_pitch", parseFloat(e.target.value))
                }
                className="form-range"
              />
              <div className="d-flex justify-content-between small text-muted">
                <span>Low</span>
                <span>Normal</span>
                <span>High</span>
              </div>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-bold">
                <i className="bi bi-volume-up-fill me-2"></i>
                Volume: {Math.round(speechConfig?.speech_volume * 100)}%
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={speechConfig?.speech_volume}
                onChange={(e) =>
                  _onChange("speech_volume", parseFloat(e.target.value))
                }
                className="form-range"
              />
              <div className="d-flex justify-content-between small text-muted">
                <span>Quiet</span>
                <span>Medium</span>
                <span>Loud</span>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={resetDefaults}
            className="btn btn-outline-secondary mt-3"
          >
            <i className="bi bi-arrow-counterclockwise me-2"></i>
            Reset to Defaults
          </button>
        </div>
      </div>
    </>
  );
}

export default VoiceConfiguration;
